import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * `tailwind-merge` solo reconoce los radios de su escala de tallas (`sm`,
 * `lg`, `2xl`…). Los nuestros tienen nombre propio y, sin declararlos, no los
 * identificaba como radios: `cn('rounded-hero', 'rounded-card')` dejaba las dos
 * clases y ganaba la que iba más abajo en la hoja de estilos, no la última de
 * la llamada. Es decir, una tarjeta no podía cambiar de radio desde fuera.
 *
 * La lista tiene que coincidir con las fichas `--radius-*` de `index.css`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ['chip', 'control', 'card', 'hero', 'sheet', 'pill'],
    },
  },
})

/**
 * Une clases resolviendo conflictos de Tailwind: la última gana.
 * Sin esto, `cn('p-2', 'p-4')` dejaría ambas y el resultado dependería del
 * orden en la hoja de estilos, no del orden de la llamada.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
